(function ($) {
    $.fn.burgerMenu = function () {
        var $self = $(this);
        var $button = $self.find('.js-burger-button');
        var $menu = $self.find('.js-menu');
        var $plug = $('.js-plug');
        var classActive = 'active';


        var init = function () {
            $button.on('click', function () {
                if($button.hasClass(classActive)) {
                    $button.removeClass(classActive);
                } else  {
                    $button.addClass(classActive);
                }
                $plug.fadeToggle();
                $menu.slideToggle();
            });
        };
        init();
    };
    $('.js-burger-menu').each(function() {
        $(this).data('burgerMenu', $(this).burgerMenu());
    })
})(jQuery);
